import { render, staticRenderFns } from "./selectionCard.vue?vue&type=template&id=9842fdce&scoped=true"
import script from "./selectionCard.vue?vue&type=script&lang=js"
export * from "./selectionCard.vue?vue&type=script&lang=js"
import style0 from "./selectionCard.vue?vue&type=style&index=0&id=9842fdce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9842fdce",
  null
  
)

export default component.exports